<template>
    <div>
        <slot></slot>
        <el-dialog
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            @close="onCancel"
            append-to-body
            :title="$t('LnkCombinefilter.title')"
            :class="['lnk-combinefilter',themeClass]"
            :visible.sync="visible">
			<div class="operate-box">
				<span class="label">{{$t('LnkCombinefilter.labelFilter')}}</span>
				<div class="oprbtns">
					<link-button :disabled="disabled"  type="line" @click="clearFilterItem">{{$t('LnkCombinefilter.btnClear')}}</link-button>
					<link-button :disabled="disabled"  @click="addFilterItem"><i class="el-icon-plus"></i>&nbsp;{{$t('LnkCombinefilter.btnAddSingleFilter')}}</link-button>
					<link-button :disabled="disabled"  @click="addFilterItem(true)"><i class="el-icon-plus"></i>&nbsp;{{$t('LnkCombinefilter.btnAddMultiFilter')}}</link-button>
				</div>
			</div>
            <div class="filterbox" ref="filterbox">
                <el-row ref="formbox" class="formbox">
                    <div :key="index" v-for="(result,index) in results"
                         class="filter-item">
                        <el-form
								:disabled="disabled"
                                :validate-on-rule-change="false"
                                :rules="getRules(result,index)"
                                :model="result">
							<el-form-item><span class="index-label">{{getIndexLabel(index)}}</span></el-form-item>
                            <!--选字段-->
                            <el-form-item prop="field">
                                <el-select
                                        clearable
                                        v-model="result.field"
                                        :multiple="result.multi"
                                        :popper-append-to-body="false"
                                        size="mini"
										:loading="isLoading"
                                        @change="onFieldChange(index)"
                                        :placeholder="$t('LnkCombinefilter.placeholderField')">
                                    <el-option
                                            v-for="(filter,lIndex) in fields"
                                            :key="filter.id || lIndex"
                                            :label="filter.name"
                                            :value="filter.field">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <!--选条件-->
                            <el-form-item prop="condition">
                                <el-select
                                        @change="validateRow(index)"
                                        clearable
                                        v-model="result.condition"
                                        :popper-append-to-body="false"
                                        :placeholder="$t('LnkCombinefilter.placeholderCondition')"
                                        size="mini">
                                    <el-option
                                            v-for="(condition,mIndex) in getCondtions(result)"
                                            :key="condition.id || mIndex"
                                            :label="condition.name"
                                            :value="condition.val">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <!--选筛选值-->
                            <el-form-item v-show="isNoValue(result)">
                                <el-input
                                        :disabled="true"
                                        size="mini"
                                        :placeholder="$t('LnkCombinefilter.placeholderInput')"></el-input>
                            </el-form-item>

                            <el-form-item
                                    v-show="!isNoValue(result) && isMultiValue(result) && !isMultiText(result)"
                                    prop="values">
                                <el-select
                                        clearable
                                        @change="validateRow(index)"
                                        v-if="result.type==='select'"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"
                                        :multiple="true"
                                        :popper-append-to-body="false"
                                        class="value-select"
                                        v-model="result.values"
                                        size="mini">
                                    <el-option
                                            v-for="(option,rIndex) in getFilterOptions(result)"
                                            :key="option.id || rIndex"
                                            :label="option.name"
                                            :value="option.val">
                                    </el-option>
                                </el-select>
                                <el-date-picker
                                        @change="validateRow(index)"
                                        v-else-if="result.type==='date'"
                                        :placeholder="$t('LnkCombinefilter.placeholderDaterange')"
                                        v-model="result.values"
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        size="mini"/>
                                <link-picklist
                                        v-else-if="result.type==='picklist' && result.isLink"
                                        @change="validateRow(index)"
                                        v-bind="result.pickProps"
                                        v-model="result.values"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"
                                        :multi="true"/>
                                <lnk-picklist
                                        v-else-if="result.type==='picklist'"
                                        picklist-type="input"
                                        @change="validateRow(index)"
                                        v-model="result.values"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"
                                        v-bind="result.pickProps"
                                        :multi="true"/>
                                <div v-else-if="result.type==='number' && result.condition==='between'"
                                     class="el-date-editor el-range-editor el-input__inner el-date-editor--daterange el-range-editor--mini">
                                    <input
                                            @input="setNumBetween(index,result)"
                                            v-model="result.start"
                                            class="el-range-input">
                                    <span class="el-range-separator">-</span>
                                    <input
                                            @input="setNumBetween(index,result)"
                                            v-model="result.end"
                                            class="el-range-input">
                                </div>
                            </el-form-item>
                            <el-form-item
                                    prop="value"
                                    v-show="!isNoValue(result) && isMultiValue(result) && isMultiText(result)">
                                <el-input
                                        @change="validateRow(index)"
                                        size="mini"
                                        v-model="result.value"
                                        :placeholder="$t('LnkCombinefilter.placeholderInput')">
									<multi-text-adder slot="suffix" v-model="result.value"/>
								</el-input>
                            </el-form-item>
                            <el-form-item
                                    v-show="!isNoValue(result) && !isMultiValue(result)"
                                    prop="value">
                                <el-select
                                        @change="validateRow(index)"
                                        v-if="result.type==='select'"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"
                                        :popper-append-to-body="false"
                                        class="value-select"
                                        v-model="result.value"
                                        size="mini">
                                    <el-option
                                            @change="validateRow(index)"
                                            v-for="(option,rIndex) in getFilterOptions(result)"
                                            :key="option.id || rIndex"
                                            :label="option.name"
                                            :value="option.val">
                                    </el-option>
                                </el-select>
                                <el-date-picker
                                        @change="validateRow(index)"
                                        v-else-if="result.type==='date'"
                                        :placeholder="$t('LnkCombinefilter.placeholderDate')"
                                        v-model="result.value"
                                        value-format="yyyy-MM-dd"
                                        size="mini">
                                </el-date-picker>
                                <link-picklist
                                        v-else-if="result.type==='picklist' && result.isLink"
                                        @change="validateRow(index)"
                                        v-bind="result.pickProps"
                                        v-model="result.value"
                                        :selected.sync="result.pickval"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"/>
                                <lnk-picklist
                                        v-else-if="result.type==='picklist'"
                                        @change="validateRow(index)"
                                        v-bind="result.pickProps"
                                        picklist-type="input"
                                        v-model="result.value"
                                        :selected.sync="result.pickval"
                                        :placeholder="$t('LnkCombinefilter.placeholderSelect')"/>
                                <el-input
                                        v-else
                                        @change="validateRow(index)"
                                        size="mini"
                                        v-model="result.value"
                                        :placeholder="$t('LnkCombinefilter.placeholderInput')"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="float: none" @click="removeFilterItem(index)" type="text"
                                           class="filter-item-del" icon="el-icon-error" v-if="!disabled"></el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-row>
            </div>
			<div class="operate-box">
				<span class="label">{{$t('LnkCombinefilter.labelLogic')}}</span>
				<el-popover class="operate-hint" placement="right" width="400">
					<div style="text-indent: 24px">
						逻辑条件表示上述添加的各个筛选条件之间的逻辑关系。
						各个筛选条件之间默认是逻辑与的关系，可打开右边的自定义开关编辑自己想要的条件。<br/>
						例如:<br/>
						&emsp;1、(A 或 B) 且 C<br/>
						&emsp;2、(A OR B) AND C<br/>
						&emsp;3、(A | B) & C <br/>
						&emsp;4、(A || B) && C <br/>
					</div>
					<link-icon slot="reference" class="comment-icon" icon="link-icon-info-circle"></link-icon>
				</el-popover>
				<div class="oprbtns">
					<span>{{$t('LnkCombinefilter.btnAdjustLogic')}}</span>
					<el-switch style="margin-left: 8px" size="mini" @change="onSwitchDiyLogic" v-model="isDiyLogic"></el-switch>
				</div>
			</div>
			<div class="logic-operator">
				<el-input v-if="isDiyLogic" type="textarea"
						  v-model="logicOperator"
						  :rows="2"
						  @keyup.native="logicOprChg"
						  resize="none"/>
				<template v-else>
					<span :key="index" v-for="(item,index) in results">
						<span v-if="index>0" class="seperator">{{$t('LnkCombinefilter.and')}}</span>
						<span>{{getIndexLabel(index)}}</span>
					</span>
				</template>
			</div>
            <span slot="footer">
                <link-button :disabled="disabled"  type="line" @click="onCancel">{{$t('global.cancel')}}</link-button>
                <link-button :disabled="disabled"  @click="showSelect">{{$t('LnkCombinefilter.btnChooseQuery')}}</link-button>
                <link-button :disabled="disabled"  @click="showSave">{{$t('global.saveAs')}}</link-button>
                <link-button :disabled="disabled"  @click="onConfirm">{{$t('global.confirm')}}</link-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="$t('LnkCombinefilter.titleSaveDialog')"
            append-to-body
            :visible.sync="saveShow"
            class="lnk-combinefilter save"
            :close-on-press-escape="false"
            :show-close="false"
            :close-on-click-modal="false">
            <el-form :model="saveModel" ref="saveform">
                <el-form-item
                    :rules="[{ required: true, message: ' ', trigger: 'blur'}]"
                    :label="$t('LnkCombinefilter.fieldFilterDescribe')"
                    prop="filterDescribe">
                    <el-input v-model="saveModel.filterDescribe" type="text"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <link-button class="light" :disabled="isSaving" @click="cancelSave">{{$t('global.cancel')}}</link-button>
                <link-button class="blue" :loading="isSaving" @click="saveSubmit">{{$t('global.confirm')}}</link-button>
            </span>
        </el-dialog>
        <lnk-picklist
            class="lnk-combinefilter selector"
            fresh-onshow
            :show.sync="selectShow"
            :grid-options="selectConf"
            @change="onSelect"
        ></lnk-picklist>
    </div>
</template>

<script>
    /* eslint-disable no-underscore-dangle,no-unused-expressions,callback-return,func-style */


import themeClass from '@mixins/theme-class';
import {
	getResults,
	isMultiText,
	isNoValue,
	makeFiltersRaw,
	getIndexLabel,
	getLogicOperator,
	getLineErrorMsg,
	checkBrackets,
	checkFormat
} from './utils';
import linkPicklist from '../lnk-picklist/link-picklist';
import MultiTextAdder from './multi-text-adder';
import {debounce} from 'throttle-debounce'
export default {
    name: 'lnk-combinefilter',
    model: {event: 'change'},
    components: {linkPicklist,MultiTextAdder},
    mixins: [themeClass],
    props: {
        value: Array,

        /* 配置数列*/
        options: {
            type: Array,
            default() {
                return [];
            }
        },

        /* 远程配置链接*/
        remote: String,

        /* 弹框的显示*/
        show: {
            type: Boolean,
            default() {
                return false;
            }
        },

        /* 接口路径*/
        interfacePath: String,

		// 底部操作按钮是否显示
		showFooterButton: {type: Boolean, default: true},
		// 弹框按钮是否禁用
		disabled: {type: Boolean, default: false},
      	// 关联的列表的context
      	context: {
          type: Object,
          default() {
            return {}
          }
        }
      },
    computed: {
        selectConf() {
            return {
                title: '选择查询条件',
                url: `${LinkVue.prefixUrl}/combinationQuery/queryByExamplePage`,
                fields: [
                    {field: 'filterDescribe', name: '描述', minWidth: 120},
                    {field: 'created', name: '创建时间', width: 160, lnkType: 'date', dateFormat: 'yyyy-MM-dd HH:mm:ss'},
                    {field: 'filterValue', name: '筛选值', hide: true}
                ],
                params: {
                    totalFlag: true,
                    interfacePath: this.getInterfacePath(),
                    pagePath: this.context.pageTabData ? this.context.pageTabData.path : location.href, //location.pathname
                }
            };
        }
    },
    data() {
        return {

            /* 查询条件*/
            conditions: {
                /* 一般字段*/
                normal: [
                    {name: '模糊查询', val: 'like'},
                    {name: '等于', val: '='},
                    {name: '包含', val: 'in'},
                    {name: '排除', val: 'not in'},
                    {name: '为空查询', val: 'IS NULL'},
                    {name: '非空查询', val: 'NOT NULL'}
                ],
                /* 数字*/
                number: [
                    {name: '大于', val: '>'},
                    {name: '大于等于', val: '>='},
                    {name: '等于', val: '='},
                    {name: '小于等于', val: '<='},
                    {name: '小于', val: '<'},
                    {name: '不等于', val: '<>'},
                    {name: '范围查询', val: 'between'},
                    {name: '包含', val: 'in'},
                    {name: '排除', val: 'not in'},
                    {name: '模糊查询', val: 'like'},
                    {name: '为空查询', val: 'IS NULL'},
                    {name: '非空查询', val: 'NOT NULL'}
                ],
                /* 可选项*/
                select: [
                    {name: '等于', val: '='},
                    {name: '包含', val: 'in'},
                    {name: '排除', val: 'not in'},
                    {name: '为空查询', val: 'IS NULL'},
                    {name: '非空查询', val: 'NOT NULL'}
                ],
                /* 日期*/
                date: [
                    {name: '晚于', val: '>='},
                    {name: '早于', val: '<='},
                    {name: '范围查询', val: 'between'},
                    {name: '模糊查询', val: 'like'},
                    {name: '为空查询', val: 'IS NULL'},
                    {name: '非空查询', val: 'NOT NULL'}
                ],
                /* picklist */
                picklist: [
                    {name: '等于', val: '='},
                    {name: '包含', val: 'in'},
                    {name: '排除', val: 'not in'},
                    {name: '为空查询', val: 'IS NULL'},
                    {name: '非空查询', val: 'NOT NULL'}
                ],
                /* 多字段单值*/
                multi: [{name: '模糊匹配', val: 'or like'}]


            },

            /* 接受条件变化的父组件名称*/
            parentName: null,

            /* 弹框的显示*/
            visible: this.show,

            /* 字段信息*/
            fields: [],

            /* 筛选条件*/
            results: [],

			/*逻辑条件*/
			logicOperator: '',

			/*是否在编辑逻辑条件*/
			isDiyLogic: false,

            /* 接口路径*/
            interfacePaths: [this.interfacePath],

            /* 保存条件的model*/
            saveModel: {},

            /* 保存弹框的显示*/
            saveShow: false,

            /* 是否正在保存*/
            isSaving: false,

            /* 选择查询弹框的显示*/
            selectShow: false,

            /* 选择查询弹框的Vue实例*/
            selectorDlg: {},

            /* 防止多次点击确定触发多次查询事件*/
            isConfirming: false,

            /* 是否已初始化 */
            isInited: false,

			/*是否正在加载数据*/
			isLoading: false
        };
    },
    watch: {
        show: {
            immediate: true,
            handler: function (val) {
                this.visible = Boolean(val);
                if (this.visible) {
                    this.onShow();
                }
            }
        },
        options: {
            immediate: true,
            handler: function (val) {
                if (this.isInited && Array.isArray(val)) {
                    this.initOptions(val);
                }
            }
        },
		interfacePath(v){
			this.$set(this.interfacePaths, 0, v);
		}
    },
    methods: {
		getIndexLabel,

        /**
         * @method：initOptions
         * @param：
         * arr：配置信息
         * @description：初始化筛选字段
         */
        async initOptions(arr) {
			this.fields = [];
			const fields = [];
            if (Array.isArray(arr)) {

            	if(!arr.find((t)=> String(t.name).toLowerCase()==='id' && String(t.field).toLowerCase()==='id')){
					arr.push({name: 'ID', field: 'id'});
				}

            	try {
					this.isLoading = true;

					/*统一拉取值列表，避免多次请求造成阻塞*/
					const lovTypes = arr.map((t)=> (t || {}).lov).filter((t)=>t);
					await this.$lov.getLovTypes(lovTypes);
					this.isLoading = false;
				}catch (e) {
					this.isLoading = false;
					this.$nav.error('拉取值列表信息失败！');
				}


                for (var i in arr) {
                    var item = arr[i];
                    var options = [];

                    /* 自定义筛选项*/
                    if (Array.isArray(item.custom)) {
                        try {
                            options = linkTools.deepCopy(item.custom);
                        } catch (e) {

                        }
                        /* 值列表筛选项*/
                    } else if (item.lov && typeof item.lov === 'string') {
                        try {
                            options
                                = item.parentLov && item.parentLovVal
                                    ? await this.$lov.getLovByParentTypeAndValue(item.lov, item.parentLov, item.parentLovVal)
                                    : await this.$lov.getLovByType(item.lov);
                        } catch (e) {

                        }
                    }
                    if (options && options.length) {
						fields.push({
                            name: item.name,
                            type: 'select',
                            field: item.field,
                            options: options
                        });
                    } else {
                        var type = item.type || item.lnkType || 'normal';
                        var tmp = {
                            name: item.name,
                            type: type,
                            field: item.field,
                            options: options
                        };
                        if (type === 'picklist') {
                            tmp.pickProps = item.pickProps;
                            tmp.relateField = item.relateField;
                            tmp.isLink = item.isLink;
                        }
						fields.push(tmp);
                    }

                }
            }
            this.fields = fields;
            this.results = [];
            this.addFilterItem();
        },

		/**
		 * @method：restoreResults
		 * @createdBy:黄健
		 * @date: 2021-02-25
		 * @params results:
		 * @description: 恢复results
		 */
		async restoreResults(results){
			await this.$lv.nextTick()
			const logicConfig = results.find((t)=> t.isLogicConfig) || {
				isDiyLogic: false,
				logicOperator: ''
			};
			this.isDiyLogic = logicConfig.isDiyLogic;
			this.logicOperator = logicConfig.logicOperator;
			this.results = results.filter((t)=> logicConfig!==t);
		},
		/**
		 * @method：onSwitchDiyLogic
		 * @createdBy:黄健
		 * @date: 2021-02-25
		 * @params:：
		 * @description: 切换逻辑条件的自定义开关后
		 */
		onSwitchDiyLogic(v){
			if(!v) return;
			this.logicOperator = this.results.map((t,i)=> getIndexLabel(i)).join(' 且 ');
		},
		/**
		 * @createdBy:黄健
		 * @date: 2021-03-19
		 * @params:：
		 * @description: 逻辑关键字两边始终保持一个空格距离
		 */
		logicOprChg(v){
			v = this.logicOperator;
			v = v.replace(/(AND|OR|&&|\|\||&|\||且|或)/gi,' $1 ');
			v = v.replace(/ +(AND|OR|&&|\|\||&|\||且|或) +/gi, ' $1 ');
			this.$nextTick(()=> this.logicOperator = v.toUpperCase());
		},
        /**
         * @method：addFilterItem
         * @param：
         * isMulti：是否多字段
         * @description：添加筛选项
         */
        addFilterItem(isMulti) {
            isMulti = typeof isMulti === 'boolean' && isMulti;
            const obj = {
                multi: isMulti,
                type: isMulti ? 'multi' : 'normal',
                condition: null,
                field: isMulti ? [] : null,
                value: '',
                values: []
            };
            this.results.splice(
                this.results.length,
                0,
                obj
            );
            this.$nextTick((res) => {
                var ref = this.$refs.filterbox;
                ref && ref.scrollTo && ref.scrollTo(0, ref.scrollHeight - ref.clientHeight);
            });

        },
        /**
         * @method：onFieldChange
         * @param：
         * index：筛选项的索引
         * @description：筛选项字段变化时的操作
         */
        onFieldChange(index) {
            if (typeof index !== 'number') return;
            var result = this.results[index];
            if (!result.multi) {
                result.value = '';
                result.values = [];
                var valid = false;
                var arr = this.getCondtions(result) || [];
                for (var i in arr) {
                    var option = arr[i];
                    if (option.val && option.val === result.condition) {
                        valid = true;
                        break;
                    }
                }
                !valid && (result.condition = null);
            }
            this.validateRow(index);
        },

        /**
         * @method：setNumBetween
         * @createdBy：HuangJian
         * @params：
         * rowIndex：行索引
         * result:这一行的数据
         * @description：响应数字范围的变化
         *
         */
        setNumBetween(rowIndex, result) {
            if (
                result.start && !isNaN(result.start)
                && result.end && !isNaN(result.end)
                && parseFloat(result.start) <= parseFloat(result.end)
            ) {
                result.values = [result.start, result.end];
            } else {
                result.values = [];
            }
            this.validateRow(rowIndex);
        },

        /**
         * @method：validateRow
         * @createdBy：HuangJian
         * @params：
         * index：行索引
         * @description：校验行的输入
         *
         */
        validateRow(index) {
            var box = this.$refs.formbox || {};
            if (box._isVue) {
                var form = (box.$getChildComponent('ElForm', false) || [])[index];
                form && form.validate && form.validate((valid) => 0);
            }

        },

        /**
         * @method：clearFilterItem
         * @param：
         * @description：清空筛选项
         */
        clearFilterItem() {
            this.results = [];
        },

        /**
         * @method：removeFilterItem
         * @param：
         * index：筛选项的索引
         * @description：删除筛选项
         */
        removeFilterItem(index) {
            this.results.splice(index, 1);
        },

        /**
         * @method：getRules
         * @createdBy：HuangJian
         * @params：
         * result：当前行数据
         * @description：根据不同的条件获取不同的校验规则
         *
         */
        getRules(result, index) {
            var rules = {
                field: [{required: true, message: ' ', trigger: ['change', 'blur']}],
                condition: [{required: true, message: ' ', trigger: ['change', 'blur']}]
            };
            if (!this.isNoValue(result)) {
                if (this.isMultiValue(result)) {
                    if (result.type === 'number' && result.condition !== 'between') {
                        var handler = function (rule, value, callback) {
                            var strRaw = typeof value === 'string' && value || '';
                            if (!value) {
                                callback(new Error(' '));
                            }
                            strRaw = strRaw.replaceAll('，', ',');
                            var tmpArr = strRaw.split(',') || [];
                            var newValues = [];
                            var flag = true;
                            for (var i in tmpArr) {
                                if (tmpArr[i]) {
                                    newValues.push(tmpArr[i]);
                                    if (isNaN(tmpArr[i])) {
                                        flag = false;
                                        break;
                                    }
                                }
                            }
                            if (!flag || !newValues.length) {
                                callback(new Error(' '));
                            } else callback();
                        };
                        rules.values = [
                            {
                                required: true,
                                message: ' ',
                                trigger: ['change', 'blur'],
                                validator: handler
                            }
                        ];
                    } else if (this.isMultiText(result)) {
                        var handler = function (rule, value, callback) {
                            var strRaw = typeof value === 'string' && value || '';
                            if (!value) {
                                callback(new Error(' '));
                            }
                            strRaw = strRaw.replaceAll('，', ',');
                            var tmpArr = strRaw.split(',') || [];
                            var newValues = [];
                            for (var i in tmpArr) {
                                tmpArr[i] && newValues.push(tmpArr[i]);
                            }
                            if (!newValues.length) {
                                callback(new Error(' '));
                            } else callback();
                        };
                        rules.value = [
                            {
                                required: true,
                                message: ' ',
                                trigger: ['change', 'blur'],
                                validator: handler
                            }
                        ];
                    } else {
                        rules.values = [{required: true, message: ' ', trigger: ['change', 'blur']}];
                    }
                } else {
                    if (result.type === 'number') {
                        var handler = function (rule, value, callback) {
                            if (value && !isNaN(value)) {
                                callback();
                            } else {
                                callback(new Error(' '));
                            }
                        };
                        rules.value = [
                            {
                                required: true,
                                message: ' ',
                                trigger: ['change', 'blur'],
                                validator: handler
                            }
                        ];
                    } else {
                        rules.value = [{required: true, message: ' ', trigger: ['change', 'blur']}];
                    }
                }
            }
            return rules;
        },

        /**
         * @method：getCondtions
         * @param：
         * index：筛选项的索引
         * @description：获取筛选项可用的筛选条件
         */
        getCondtions(result) {
            if (typeof result !== 'object') return;
            var filterItem = null;
            var type = result.type;

            if (!result.multi) {
                for (var i in this.fields) {
                    if (this.fields[i].field === result.field) {
                        filterItem = this.fields[i];
                        break;
                    }
                }
            }
            if (filterItem) {
                type = filterItem.type;
                if (type === 'picklist') {
                    result.pickProps = filterItem.pickProps;
                    result.relateField = filterItem.relateField;
                    result.isLink = filterItem.isLink;
                }
            }

            var rslt = null;
            try {
                rslt = this.conditions[type];
            } catch (e) {

            }
            result.type = type;
            return rslt || this.conditions.normal;
        },

        /**
         * @method：getFilterOptions
         * @param：
         * result：筛选项的值
         * @description：获取筛选项可选值
         */
        getFilterOptions(result) {
            if (typeof result !== 'object') return;
            var filterItem = null;

            if (!result.multi) {
                for (var i in this.fields) {
                    if (this.fields[i].field === result.field) {
                        filterItem = this.fields[i];
                        break;
                    }
                }
            }
            var rslt = null;
            if (filterItem) {
                rslt = filterItem.options;
            }
            return rslt || [];
        },

        /**
         * @method：isMultiValue
         * @param：
         * result：筛选项的值
         * @description：是否为单字段多值类型
         */
        isMultiValue(result) {
            if (typeof result !== 'object') return;
            var rslt
                = result.condition === 'in'
                || result.condition === 'not in'
                || result.condition === 'between';
            result.multival = rslt;
            return rslt;
        },

        /**
         * @method：isMultiText
         * @createdBy:HuangJian
         * @date:2018/12/4
         * @params：
         * @description：判断是否为用 ，隔开的多值字段
         */
        isMultiText(result) {
            return isMultiText(result);
        },

        /**
         * @method：isNoValue
         * @param：
         * index：筛选项的索引
         * @description：是否要需要筛选值
         */
        isNoValue(result) {
            return isNoValue(result);
        },

        /**
         * @method：checkValid
         * @createdBy：HuangJian
         * @params：
         * @description：检查数据是否符合条件
         *
         */
        checkValid() {
			const lines = this.$getChildComponent('ElForm', false) || [];
			for (let i in lines){
				const l = lines[i];
				let msg = getLineErrorMsg(l);
				if(msg){
					this.$message.error(`筛选条件${getIndexLabel(i)}：${msg}`);
					return false;
				}
			}
            return this.isDiyLogic ? this.checkLogicOperator() : true;
        },
		/**
		 * @createdBy:黄健
		 * @date: 2021-03-18
		 * @params:：
		 * @description: 校验逻辑表达式的格式
		 */
		checkLogicOperator(){
			let logicOperator = getLogicOperator(this.logicOperator);
			logicOperator = logicOperator.replace(/AND/g, '&').replace(/OR/g,'|');
			if(!logicOperator.trim()){
				this.$message.error('逻辑条件：逻辑表达式不能为空');
				return false;
			}
			const wrongChars = logicOperator.match(/[^A-Z0-9&\|\s\(\)]+/g) || [];
			if(wrongChars.length){
				this.$message.error(`逻辑条件：输入了无效字符 ${wrongChars.join('、')}`);
				return false;
			}
			if(!checkBrackets(logicOperator)){
				this.$message.error(`逻辑条件：表达式中的括号未闭合`);
				return false;
			}
			if(!checkFormat(logicOperator)){
				this.$message.error(`逻辑条件：条件名格式不对 或 缺少逻辑关键字`);
				return false;
			}
			const labelsMap = {};
			this.results.forEach((r,i)=> labelsMap[getIndexLabel(i)]=true);
			const nulLabels = (logicOperator.match(/[A-Z]\d*/g) || []).filter((k)=> !labelsMap[k]);
			if(nulLabels.length > 0){
				this.$message.error(`逻辑条件：没有与 ${nulLabels.join('、')} 对应的筛选条件`);
				return false;
			}
			return true;
		},
        /**
         * @method：clearCheck
         * @createdBy：HuangJian
         * @params：
         * @description：清楚校验状态
         *
         */
        clearCheck() {
            var box = this.$refs.formbox || {};
            if (box._isVue) {
                var formList = box.$getChildComponent('ElForm', false) || [];
                formList.forEach((form) => {
                    form.clearValidate && form.clearValidate();
                });
            }
        },

        /**
         * @method：closeDialog
         * @createdBy：HuangJian
         * @params：
         * @description：关闭对话框
         *
         */
        closeDialog() {
            this.selectShow = false;
            this.savaShow = false;
            this.$nextTick(() => {
                this.visible = false;
                this.$emit('update:show', false);
            });
        },

        /**
         * @method：onConfirm
         * @createdBy：HuangJian
         * @params：
         * @description：点击确定
         */
        onConfirm() {
            if (this.isConfirming) return;
            this.isConfirming = true;
            if (!this.checkValid()) {
                this.isConfirming = false;
                return;
            }
            const logicOperator = this.isDiyLogic ? getLogicOperator(this.logicOperator) : '';
            const {filtersRaw, filterOperator} = makeFiltersRaw(this.results, logicOperator);
            this.$emit('change', filtersRaw, filterOperator);
            if (this.parentName) {
                this.$dispatch(this.parentName, 'combfilter-change', filtersRaw, filterOperator);
            }
            this.closeDialog();
        },
        /**
         * @method：onSelect
         * @createdBy：HuangJian
         * @params：
         * @description：选择查询条件
         *
         */
        async onSelect(v) {
        	if(!v) return;
        	let results = [];
        	let filterValue = {}
			try {
				results = JSON.parse(v.resultsRaw);
				filterValue= JSON.parse(v.filterValue);
				/*为了兼容原有的数据*/
				if(Array.isArray(filterValue)){
					filterValue = {filtersRaw: filterValue, filterOperator: ''};
				}
			}finally {
        		await this.$lv.nextTick();
        		await this.restoreResults(results);
				await this.$lv.nextTick();
				this.$emit('change', filterValue.filtersRaw, filterValue.filterOperator);
				if (this.parentName) {
					this.$dispatch(this.parentName, 'combfilter-change', filterValue.filtersRaw, filterValue.filterOperator);
				}
				this.closeDialog();
			}
        },

        /**
         * @method：onCancel
         * @createdBy：HuangJian
         * @params：
         * @description：取消查询
         *
         */
        onCancel() {
            this.closeDialog();
        },

        /**
         * @method：
         * @createdBy：HuangJian
         * @date：2018/11/5
         * @params：
         * @description：打开弹出框时触发
         *
         */

        onShow() {
            // this.results=[];
            this.selectShow = false;
            this.savaShow = false;
            this.isConfirming = false;
            if (!this.results.length) {
                this.addFilterItem();
            }
            this.$nextTick(() => {
                this.clearCheck();
            });

        },
        /**
         * @method：checkInterFaceValid
         * @createdBy：HuangJian
         * @params：
         * @description：检查是否配置了接口路径
         *
         */
        checkInterFaceValid() {
            var value = true;
            if (!this.getInterfacePath()) {
                this.$message({type: 'error', message: '未指定接口路径！'});
                value = false;
            }
            return value;
        },
        /**
         * @method：showSelect
         * @createdBy：HuangJian
         * @params：
         * @description：打开选择查询
         *
         */
        showSelect() {
            if (!this.checkInterFaceValid()) {
                return;
            }
            this.selectShow = true;
        },
        /**
         * @method：getInterfacePath
         * @createdBy:HuangJian
         * @date:2019/1/18
         * @params：
         * @description：获取查询的接口路径
         */
        getInterfacePath() {
            const url = this.queryurl || this.interfacePaths[1] || this.interfacePaths[0];
            return (url || '').replaceAll(appCtx.ctxPath, '') || `${LinkVue.prefixUrl}/orgnization/picklist`;
        },
        /**
         * @method：showSave
         * @createdBy：HuangJian
         * @params：
         * @description：打开保存编辑框
         *
         */
        showSave() {
            if (!this.checkInterFaceValid()) {
                return;
            }
            if (!this.results.length) {
                this.$message.warning('至少要保留一个筛选条件');
                return;
            }
            if (!this.checkValid()) {
                return;
            }
			const logicOperator = this.isDiyLogic ? getLogicOperator(this.logicOperator) : '';
			const {filtersRaw, filterOperator} = makeFiltersRaw(this.results, logicOperator);
            const results = getResults(this.results) || [];
            results.push({
				isLogicConfig: true,
				isDiyLogic: this.isDiyLogic,
				logicOperator: this.logicOperator
			});
			results.forEach((result) => {
				delete result.multival;
				delete result.pickProps;
			});
            this.saveModel = {
                interfacePath: this.getInterfacePath(),
                pagePath: this.context.pageTabData ? this.context.pageTabData.path : location.href, //location.pathname,
                filterValue: JSON.stringify({
					filtersRaw,
					filterOperator
				}),
                resultsRaw: JSON.stringify(results),
                publicFlag: 'N'
            };
            this.saveShow = true;
        },

        /**
         * @method：cancelSave
         * @createdBy：HuangJian
         * @params：
         * @description：取消保存
         *
         */
        cancelSave() {
            if (!this.saveShow) return;
            var saveform = this.$refs.saveform || {};
            saveform.clearValidate && saveform.clearValidate();
            this.saveShow = false;
        },
        /**
         * @method：saveSubmit
         * @createdBy：HuangJian
         * @params：
         * @description：保存到后台
         *
         */
        saveSubmit() {
            if (this.isSaving) return;
            this.isSaving = true;
            var saveform = this.$refs.saveform || {};
            var valid = false;
            saveform.validate && saveform.validate((val) => {
                valid = val;
            });
            if (!valid) {
                this.$message({type: 'error', message: '请先填写描述！'});
                this.isSaving = false;
                return;
            }
            saveform.clearValidate && saveform.clearValidate();
            var url = `/action/${LinkVue.prefixUrl}/combinationQuery/insert`;
            var data = this.saveModel;
            this.$http.post(url, data, true).then((data) => {
                if (data.success) {
                    this.$message({type: 'success', message: '已保存！'});
                    this.$emit('save', data.result)
                    this.saveShow = false;
                    this.clearCheck();
                } else {
                    this.$message({type: 'error', message: data.result || '未知错误！'});
                }
                this.isSaving = false;
            }).
                catch((err) => {
              		this.$message({type: 'error', message: err});
                }).finally(() => {
              this.saveShow = false;
			})
        },

        /**
         * @method：fetchRemote
         * @createdBy：HuangJian
         * @params：
         * url：远程配置路劲
         * @description：获取远程配置信息
         *
         */
        fetchRemote(url) {
            this.$http.post(url).then((data) => {
                var errorMsg = '加载远程配置失败';
                if (
                    data
                    && typeof data === 'object'
                    && Array.isArray(data.options)
                ) {
                    if (data.interfacePath) {
                        this.interfacePaths[1] = data.interfacePath;
                    }
                    this.initOptions(data.options);
                } else if (
                    data
                    && typeof data === 'string'
                ) {
                    try {
                        var obj = JSON.parse(data);
                        if (
                            obj
                            && obj.options
                            && Array.isArray(obj.options)
                        ) {
                            if (obj.interfacePath) {
                                this.interfacePaths[1] = obj.interfacePath;
                            }
                            this.initOptions(obj.options);
                        }
                    } catch (e) {
                        this.$message({type: 'error', message: errorMsg});
                    }
                } else {
                    this.$message({type: 'error', message: errorMsg});
                }
            }).
                catch((err) => {
              		this.$message({type: 'error', message: err});
                    // if (!err.response) {
                    //     this.$message({type: 'error', message: '请检查与服务器的连接！'});
                    //     return;
                    // }
                    // if (err.response && err.response.status === 404) {
                    //     this.$message({type: 'error', message: '远程配置信息不存在！'});
                    // }
                });
        }
    },
    created() {
		this.logicOprChg = debounce(800, this.logicOprChg).bind(this);
		this.$on('setFilterOptions', (arr) => {
            this.initOptions(arr);
        });
        this.$on('setParentName', (val) => {
            if (val && typeof val === 'string') {
                this.parentName = val;
            }
        });
        this.$on('setQueryUrl', (val) => {
            if (val && typeof val === 'string') {
                this.queryurl = val;
            }
        });

        this.$on('openDialog', () => {
            if (this.visible) return;
            this.visible = true;
            this.onShow();
        });

        this.$on('closeDialog', () => {
            if (!this.visible) return;
            this.closeDialog();
        });

        if (
            this.remote
            && typeof this.remote === 'string'
        ) {
            this.fetchRemote(this.remote);
        } else {
            this.initOptions(this.options);
        }
    },
    mounted() {
        var showButton = this.$getChildComponent('ElButton') || {};
        if (showButton._isVue) {
            showButton.$on('click', () => {
                this.visible = !this.visible;
                if (!this.visible) return;
                this.visible = true;
                this.onShow();
            });
        }
    }
};
</script>

<style lang="scss">

	.lnk-combinefilter{
		.clearfix:before,
		.clearfix:after {
			content: " ";
			display: table;
		}
		.el-select-dropdown__item {
			font-size: 12px;
			height: 25px;
			line-height: 25px;
		}
		.el-select-dropdown__empty {
			padding: 5px 0;
			font-size: 12px;
		}
		.el-dialog {
			width: 800px;
			.el-dialog__body {
				background: #F6F7FB;
				padding: 16px 0!important;
			}
			.el-dialog__footer {
				text-align: center;
				padding: 12px 0;
			}
			.el-dialog__footer .el-button {
				width: 68px;
				height: 32px;
				line-height: 32px;
				padding: 0;
				float: none !important;
				border-radius: 0;
				font-size: 12px;
			}
		}
		.label {
			font-size: 12px;
			font-weight: bold;
			margin: 0 0 16px 24px;
		}
		.index-label{
			color: #aaa;
			display: inline-block;
			width: 20px;
			text-align: center;
			margin-right: 8px;
		}
		.filterbox {
			max-height: 248px;
			overflow-x: hidden;
			overflow-y: auto;
			padding: 0 0 8px 24px;

			.filter-item {
				overflow: hidden;
				&+.filter-item{
					margin-top: 16px;
				}
				.el-input {
					width: 220px;
				}
				.el-input__inner {
					width: 220px;
					font-size: 12px;
					border-radius: 0;
					height: 28px;
					line-height: 28px;
				}
				.el-select {
					margin-right: 8px;
				}
				.el-select.multi-inputbox{
					margin-right: 0;
				}
				.el-select-dropdown__item span {
					line-height: 25px !important;
				}
				.el-select-dropdown.el-popper {
					border-radius: 0 !important;
				}
				.el-select .el-input.is-disabled .el-input__inner {
					height: 28px;
				}
				.el-select.value-select {
					margin-right: 0;
				}
				.el-form-item {
					display: inline-block;
					margin-bottom: 0;
				}
				.el-form-item__content {
					line-height: 28px;
				}
				.el-date-editor .el-range__icon {
					font-size: 12px;
				}
				.filter-item-del {
					margin-left: 20px;
					font-size: 14px;
					color: #BBBBBB;
					padding: 0;
					border: 0;
				}
			}
		}

		.filterbox + .operate-box{
			margin-top: 8px;
			line-height: 16px;
		}

		.operate-box{
			line-height: 28px;
			padding-bottom: 8px;
			margin-bottom: 8px;
			border-bottom: 1px dashed #EEE;
			.operate-hint{
				color: #AAA;
				margin-left: 4px;
				cursor: pointer;
			}
			.oprbtns{
				float: right;
				margin-right: 24px;
			}
			.link-button+.link-button{
				margin-left: 8px;
			}
		}
		.logic-operator {
			margin: 16px 16px 0 16px;
			font-size: 18px;
			text-align: center;
			.seperator{
				margin: 0 8px;
			}
			.el-textarea__inner{
				border-radius: 0;
				font-size: 18px;
			}
		}
	}

    .lnk-combinefilter.save .el-dialog {
        width: 504px;
    }

    .lnk-combinefilter.selector .el-dialog {
        width: 680px;
    }

    .lnk-combinefilter.selector .el-dialog .el-dialog__body {
        padding: 24px 16px 16px 16px;
    }

    .lnk-combinefilter.save .el-dialog .el-dialog__body {
        padding: 24px 16px 16px 16px;
    }

    .lnk-combinefilter.save .el-dialog .el-form .el-form-item__label {
        width: 115px;
        font-size: 12px;
        font-weight: bold;
        color: #909399;
    }

    .lnk-combinefilter.save .el-dialog .el-form .el-form-item__content {
        margin-left: 115px;
    }

    .lnk-combinefilter.save .el-dialog .el-form .el-input__inner {
        border-radius: 0;
        width: 280px;
        height: 28px;
        line-height: 28px;
    }
</style>
